module.exports = __webpack_public_path__ + "img/battle-banner-1.452df8b8.jpg";